export const CONSTANTS_CRM = {
  OPPORTUNITY_CONVERTITBILITY: [
    { name: 'Hot', value: '3', icon: '/assets/img/icons/hot.svg' },
    { name: 'Cold', value: '1', icon: '/assets/img/icons/cold.svg' },
    { name: 'Warm', value: '2', icon: '/assets/img/icons/warm.svg' },
  ] as Convertibility[],

  CALL_OUTCOME: [
    {
      name: 'No Answer / Left Message',
      shortname: 'noanswer',
      value: 1,
      icon: 'fa fa-phone',
      iconColor: '#ED8536',
      class: 'text-sm bg-orange-500 border-orange-500',
      key:'NO_ANSWER_LEFT_MESSAGE'
    },
    {
      name: 'Contact Made',
      shortname: 'contactmade',
      value: 2,
      icon: 'fa fa-check-square',
      iconColor: '#4A9FB5',
      class: 'bg-cyan-600 border-cyan-600',
      key:'CONTACT_MADE'
    },
    {
      name: 'Book Tour',
      shortname: 'booktour',
      value: 3,
      icon: 'fa fa-calendar-plus',
      iconColor: '#408558',
      class: 'p-ripple ng-star-inserted',
      key:'BOOK_TOUR'
    },
    {
      name: 'Sign Up',
      shortname: 'signup',
      value: 4,
      icon: 'fa fa-money-bill',
      iconColor: '#CA444A',
      class: 'p-ripple p-button-primary',
      key:'SIGN_UP'
    },
    {
      name: 'Not Interested',
      shortname: 'notintrested',
      value: 5,
      icon: 'fa fa-times',
      iconColor: '#316CF3',
      class: 'p-ripple p-button-danger',
      key:'NOT_INTERESTED'
    },
    {
      name: 'Successfull Followup Up',
      shortname: 'followup',
      value: 6,
      icon: 'fa fa-check-square',
      iconColor: '#4A9FB5',
      class: 'bg-cyan-600 border-cyan-600',
      key:'FOLLOW_UP'
    }
  ] as Outcome[],

  TOUR_OUTCOME: [
    {
      name: 'Not Interested',
      shortname: 'notintrested',
      value: 1,
      icon: 'fa fa-times',
      iconColor: '#ED8536',
      class: 'p-ripple p-button-danger',
      key:'NOT_INTERESTED'
    },
    {
      name: 'No Show',
      shortname: 'noshow',
      value: 2,
      icon: 'fa fa-ban',
      iconColor: '#4A9FB5',
      class: 'p-ripple p-button-warning',
      key:'NO_SHOW'
    },
    {
      name: 'Reschedule',
      shortname: 'reschedule',
      value: 3,
      icon: 'fa fa-calendar-plus',
      iconColor: '#316CF3',
      class: 'p-ripple p-button-primary',
      key:'RESCHEDULE'
    },
    {
      name: 'Still Thinking',
      shortname: 'stillthinking',
      value: 4,
      icon: 'fa fa-question',
      iconColor: '#408558',
      class: 'p-ripple p-button-primary',
      key:'STILL_THINKING'
    },
    {
      name: 'Signing-up',
      shortname: 'signup',
      value: 5,
      icon: 'fa fa-ticket',
      iconColor: '#CA444A',
      class: 'p-ripple p-button-primary',
      key:'SIGN_UP'
    }
    // {
    //   name: 'BookTrial',
    //   shortname: 'booktrial',
    //   value: 6,
    //   icon: 'fa fa-calendar-plus',
    //   iconColor: '#408558',
    //   class: 'p-ripple p-button-primary',
    //   key:'BOOK_TRIAL'
    // },
  ] as Outcome[],

};

interface Convertibility {
  name: string;
  value: string;
  icon: string;
}

export interface Outcome {
  name: string;
  shortname:string;
  value: number;
  icon: string;
  iconColor: string;
  class: string;
  key:string;
}


